import { render, staticRenderFns } from "./DettaglioNotifiche.vue?vue&type=template&id=36889d72&scoped=true&"
import script from "./DettaglioNotifiche.vue?vue&type=script&lang=js&"
export * from "./DettaglioNotifiche.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioNotifiche.vue?vue&type=style&index=0&id=36889d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36889d72",
  null
  
)

export default component.exports